<div class="product-list" [class.product-list--grid]="viewMode === 'grid'" [class.product-list--table]="viewMode === 'table'" [class.product-list--sidebar-open]="showSidebar" [class.product-list--consolidated-feed]="isConsolidatedFeed" [class.product-list--supplier]="!!supplierId">
    <ng-container *ngIf="isMobile">
            <div class="flex flex-col mb-4" *ngIf="!supplierId">
                <div class="product-list__mobile-toolbar" *ngIf="breadcrumbs$ | async as bc">
                    <vsf-collection-breadcrumbs [breadcrumbs]="bc"></vsf-collection-breadcrumbs>

                    <div class="relative">
                        <button (click)="toggleMobileMenu()" class="product-list__mobile-menu-btn" aria-label="Toggle mobile menu">
                            <img src="assets/icons/more-vertical.svg" alt="" class="w-5 h-5 text-gray-900" />
                        </button>
                        <div *ngIf="mobileMenuOpen" class="product-list__mobile-dropdown">
                            <div class="product-list__mobile-dropdown-item">
                                <vsf-export-download-menu
                                    label="Download Catalog"
                                    buttonClass="product-list__mobile-download"
                                    iconSrc="assets/icons/download-icon.svg"
                                    [showShareLink]="false"
                                    [skipFormatPicker]="true"
                                    ariaLabel="Download catalog"
                                    (download)="onCatalogDownload($event); mobileMenuOpen = false"
                                    (shareLink)="shareCatalogLink($event); mobileMenuOpen = false"
                                ></vsf-export-download-menu>
                            </div>
                            <div class="product-list__mobile-dropdown-rule"></div>
                            <div class="product-list__mobile-dropdown-item">
                                <vsf-upload-cart-csv
                                [consolidatedFeedImport]="isConsolidatedFeed"
                                    buttonLabel="Import cart"
                                    [customClass]="'product-list__upload-cart-inline'"
                                    [consolidatedFeedPricingIds]="consolidatedFeedPricingIds"
                                    [failedProductGtins]="failedProductGtins"
                                    [moqViolations]="moqViolations"
                                    (failedProductGtinsChange)="failedProductGtins = $event; mobileMenuOpen = false"
                                    (moqViolationsChange)="moqViolations = $event; mobileMenuOpen = false"
                                ></vsf-upload-cart-csv>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="product-list__mobile-filter-bar" *ngIf="!isConsolidatedFeed">
                <button (click)="openFilterModal()" class="product-list__mobile-filter-open" aria-label="Open filters">
                    <img src="assets/icons/filter-icon.svg" alt="" class="w-6 h-6" />
                    Filters
                    <span *ngIf="(activeFilters$ | async)?.length" class="product-list__filter-count-badge">
                        {{ (activeFilters$ | async)?.length }}
                    </span>
                </button>
                <button (click)="clearAllFilters()" class="product-list__mobile-filter-clear" aria-label="Clear filters">
                    Clear filters
                </button>
            </div>
    </ng-container>

    <ng-container *ngIf="!isMobile && !supplierId">
            <vsf-product-list-header
                [breadcrumbs$]="breadcrumbs$"
                [activeFilters$]="activeFilters$"
                [activeSortLabel]="activeSortLabel"
                [sortDropdownOpen]="sortDropdownOpen"
                [sortOptions]="sortOptions"
                [viewMode]="viewMode"
                [failedProductGtins]="failedProductGtins"
                [moqViolations]="moqViolations"
                [downloadLabel]="isConsolidatedFeed ? 'Download Consolidated Feed' : 'Download Catalog'"
                [isConsolidatedFeed]="isConsolidatedFeed"
                [pageTitle]="catalogPageTitle"
                [offerCount]="catalogOfferCount"
                [brandCount]="catalogBrandCount"
                [sellerCount]="catalogSellerCount"
                [showFreshPrices]="!isSearchResultsPage"
                (toggleSidebarEvent)="toggleSidebar()"
                (removeFilterEvent)="removeFilter($event)"
                (clearAllFiltersEvent)="clearAllFilters()"
                (toggleSortDropdownEvent)="toggleSortDropdown()"
                (selectSortOptionEvent)="selectSortOption($event)"
                (toggleViewModeEvent)="toggleViewMode($event)"
                (downloadAllProductsEvent)="onCatalogDownload($event)"
                (shareCatalogLinkEvent)="shareCatalogLink($event)"
                (failedProductGtinsChange)="failedProductGtins = $event"
                (moqViolationsChange)="moqViolations = $event"
            ></vsf-product-list-header>
    </ng-container>

    <div *ngIf="isConsolidatedFeed" class="cf-banner">
        <div class="cf-banner__intro">
            <span class="cf-banner__new">NEW</span>
            <h1 class="cf-banner__title">Buy stock from multiple suppliers with one Venduro order</h1>
            <p class="cf-banner__lead">
                Choose mixed-brand stock from our consolidated list. We place the orders, collect the goods and consolidate everything into one shipment and one invoice.
            </p>
        </div>
        <div class="cf-banner__panel">
            <div class="cf-banner__tier-label">Select a tier to see prices and MOV progress</div>
            <div class="cf-banner__tiers">
                <button
                    type="button"
                    *ngFor="let tier of consolidatedFeedMovTiers"
                    class="cf-banner__tier"
                    [class.cf-banner__tier--active]="isConsolidatedMovTierSelected(tier)"
                    (click)="selectConsolidatedMovTier(tier)"
                >
                    {{ formatConsolidatedMovTier(tier) }}
                </button>
            </div>
            <div class="cf-banner__row">
                <span class="cf-banner__minimum">
                    Minimum: <b>{{ formatConsolidatedMovTier(selectedConsolidatedMovTierCents) }}</b>
                </span>
                <span class="cf-banner__remaining" *ngIf="getConsolidatedProgress() < 100">
                    <b>{{ getConsolidatedRemaining() | formatPrice }}</b> remaining
                </span>
                <span class="cf-banner__remaining" *ngIf="getConsolidatedProgress() >= 100">
                    Ready for checkout
                </span>
            </div>
            <div class="cf-banner__progress">
                <div class="cf-banner__progress-fill" [style.width.%]="getConsolidatedProgress()"></div>
            </div>
            <div class="cf-banner__notices">
                <div class="cf-banner__notice cf-banner__notice--preview" *ngIf="showConsolidatedPreviewNotice()">
                    <img src="assets/icons/info-circle.svg" alt="" />
                    <span>
                        <b>Previewing MOV {{ formatConsolidatedMovTier(selectedConsolidatedMovTierCents) }}.</b>
                        Add {{ getConsolidatedRemaining() | formatPrice }} to unlock.
                    </span>
                </div>
                <div class="cf-banner__notice cf-banner__notice--checkout" *ngIf="showConsolidatedCheckoutNotice()">
                    <img src="assets/icons/info-circle.svg" alt="" />
                    <span>
                        Add <b>{{ getConsolidatedCheckoutRemaining() | formatPrice }}</b>
                        to checkout at MOV {{ formatConsolidatedMovTier(consolidatedFeedCheckoutMovCents) }}.
                    </span>
                </div>
            </div>
            <div class="cf-banner__feeds">
                <div class="cf-banner__feeds-links">
                    <span class="cf-banner__connect">
                        <img src="assets/icons/link-icon.svg" alt="" />
                        Connect feed:
                    </span>
                    <button type="button" class="cf-banner__feed-link" (click)="connectFeed('csv')">CSV</button>
                    <button type="button" class="cf-banner__feed-link" (click)="connectFeed('xml')">XML</button>
                    <button type="button" class="cf-banner__feed-link" (click)="connectFeed('xlsx')">XLSX</button>
                </div>
                <button
                    type="button"
                    class="cf-banner__download"
                    aria-label="Download consolidated feed"
                    (click)="downloadConsolidatedFeed()"
                >
                    <img src="assets/icons/download-icon.svg" alt="" />
                    Download Consolidated Feed
                </button>
            </div>
        </div>
    </div>

    <div
        *ngIf="isConsolidatedFeed && consolidatedFeedLoaded && consolidatedFeedPricingIds.length === 0"
        class="rounded-lg border border-gray-200 bg-white p-8 text-center text-gray-600 mb-4"
    >
        No products are available in this feed yet.
    </div>

    <div *ngIf="filterModalVisibility && isMobile && !isConsolidatedFeed" class="product-list__filter-modal">
            <div class="product-list__filter-modal-header">
                <h2 class="text-lg font-bold">Filters</h2>
                <button (click)="openFilterModal()" class="product-list__filter-modal-close" aria-label="Close filters">
                    <img src="assets/icons/close-icon.svg" alt="" class="w-6 h-6" />
                </button>
            </div>
            <div class="product-list__filter-modal-scroll">
                <vsf-product-list-controls
                    [facetValues]="facetValues"
                    [activeFacetValueIds]="activeFacetValueIds$ | async"
                    [totalResults]="unfilteredTotalItems"
                    [facetTotalItems]="facetTotalItems"
                    [loading]="filtersLoading$ | async"
                    [supplierId]="supplierId"
                    [showSupplyTypeFilter]="showSupplyTypeFilter"
                    [isConsolidatedFeed]="isConsolidatedFeed"
                    (openFilterModal)="openFilterModal()"
                    (requestMoreFacets)="onRequestMoreFacets()"
                    (facetSearchTermChange)="onFacetSearchTermChange($event)"
                >
                </vsf-product-list-controls>
            </div>
            <div class="product-list__filter-modal-footer">
                <button (click)="clearAllFilters(); openFilterModal()" class="product-list__filter-modal-btn product-list__filter-modal-btn--secondary" aria-label="Clear all filters">Clear All</button>
                <button (click)="openFilterModal()" class="product-list__filter-modal-btn product-list__filter-modal-btn--primary" aria-label="Apply filters">Apply Filters</button>
            </div>
    </div>

    <vsf-product-list-supplier-card
        *ngIf="supplierId && supplierInfo"
        [supplierInfo]="supplierInfo"
        [supplierSpecificTotal]="supplierSpecificTotal"
        [isPreOrder]="isSupplierPreOrder()"
        [progressPercentage]="getProgressPercentage()"
        [progressColor]="getProgressColor()"
        [statusText]="getCsvFileStatusText()"
        [deliveryTerm]="getSupplierDeliveryTerm()"
        [showPrePayment]="showSupplierPrePayment()"
        [pricelistCardText]="pricelistCardText"
        [selectedTierMinCents]="selectedSupplierTierMinCents"
        (downloadSupplierProductsEvent)="downloadSupplierProducts($event)"
        (shareSupplierLinkEvent)="shareSupplierLink($event)"
        (selectTierEvent)="onSelectSupplierTier($event)"
    ></vsf-product-list-supplier-card>

    <ng-container *ngIf="collection$ | async as collection">
        <div
            *ngIf="failedProductGtins?.length > 0 || moqViolations?.length > 0"
            class="product-list__error-box"
        >
            <ng-container *ngIf="failedProductGtins?.length > 0">
                <p>{{ importText.NOT_FOUND_EANS }}</p>
                <div class="flex flex-col">
                    <p *ngFor="let gtin of failedProductGtins" class="text-wrap">
                        {{ gtin }}
                    </p>
                </div>
            </ng-container>

            <ng-container *ngIf="moqViolations?.length > 0">
                <p [class.mt-3]="failedProductGtins?.length > 0">
                    {{ importText.MOQ_NOT_MET }}
                </p>
                <div class="flex flex-col">
                    <p
                        *ngFor="let violation of moqViolations"
                        class="text-wrap"
                    >
                        {{ violation.gtin }}
                    </p>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="!isConsolidatedFeed && collection.children.length">
            <div class="mb-10">
                <h2 class="product-list__collections-title">Collections</h2>
                <div class="product-list__collections-grid">
                    <vsf-collection-card *ngFor="let child of collection.children" [collection]="child"></vsf-collection-card>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <div class="product-list__body">
       
        <aside class="product-list__sidebar" *ngIf="showSidebar && !isMobile && !isConsolidatedFeed">
            <vsf-product-list-controls
                [facetValues]="facetValues"
                [activeFacetValueIds]="activeFacetValueIds$ | async"
                [totalResults]="unfilteredTotalItems"
                [facetTotalItems]="facetTotalItems"
                [loading]="filtersLoading$ | async"
                [supplierId]="supplierId"
                [showSupplyTypeFilter]="showSupplyTypeFilter"
                [isConsolidatedFeed]="isConsolidatedFeed"
                (openFilterModal)="openFilterModal()"
                (requestMoreFacets)="onRequestMoreFacets()"
                (facetSearchTermChange)="onFacetSearchTermChange($event)"
                (collapseFilters)="toggleSidebar()"
            >
            </vsf-product-list-controls>
        </aside>

        <div class="product-list__main">
            <button
                *ngIf="!showSidebar && !isMobile && !isConsolidatedFeed"
                type="button"
                class="product-list__show-filters"
                (click)="toggleSidebar()"
            >
                <img src="assets/icons/filter-icon.svg" alt="" />
                Filters
            </button>

            <div class="product-list__supplier-toolbar" *ngIf="supplierId && !isMobile">
                <form
                    class="product-list__supplier-search"
                    (submit)="$event.preventDefault(); submitSupplierPricelistSearch()"
                >
                    <img src="assets/icons/search-icon.svg" alt="" />
                    <input
                        type="search"
                        [(ngModel)]="supplierPricelistSearchTerm"
                        name="supplierPricelistSearch"
                        placeholder="Search in this pricelist"
                        aria-label="Search in this pricelist"
                        (input)="onSupplierPricelistSearchInput()"
                        (search)="onSupplierPricelistSearchInput()"
                    />
                </form>
                <div class="product-list__supplier-toolbar-actions">
                    <div class="relative">
                        <button
                            type="button"
                            class="product-list__supplier-sort"
                            (click)="toggleSortDropdown()"
                            aria-label="Sort options"
                        >
                            Sort: {{ activeSortLabel }}
                            <img src="assets/icons/chevron-down-outline.svg" alt="" />
                        </button>
                        <div *ngIf="sortDropdownOpen" class="product-list__dropdown-menu product-list__dropdown-menu--stats">
                            <button
                                type="button"
                                *ngFor="let option of supplierSortOptions"
                                (click)="selectSortOption(option)"
                                class="product-list__dropdown-option"
                                [class.product-list__dropdown-option--active]="activeSortLabel === option.label"
                            >
                                {{ option.label }}
                            </button>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="product-list__supplier-add-all"
                        (click)="addSelectedSupplierProductsToCart()"
                        [disabled]="addingAllSupplierProducts || selectedSupplierProductCount === 0"
                    >
                        {{ addingAllSupplierProducts ? 'Adding…' : ('Add all ' + selectedSupplierProductCount + ' to cart') }}
                    </button>
                </div>
            </div>

            <div
                class="product-list__active-filters"
                *ngIf="!isConsolidatedFeed && !isMobile && !supplierId"
            >
                <div class="product-list__active-filters-chips">
                    <ng-container *ngIf="(activeFilters$ | async) as activeFilters">
                        <ng-container *ngIf="activeFilters.length">
                            <div *ngFor="let filter of activeFilters" class="product-list__filter-chip">
                                <span>{{ filter.label }}: {{ filter.value }}</span>
                                <button
                                    type="button"
                                    (click)="removeFilter(filter)"
                                    class="product-list__filter-chip-remove"
                                    aria-label="Remove filter"
                                >×</button>
                            </div>
                            <button
                                type="button"
                                (click)="clearAllFilters()"
                                class="product-list__clear-filters-link"
                                aria-label="Clear all active filters"
                            >Clear all</button>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="product-list__view-toggle" *ngIf="!supplierId">
                    <button
                        type="button"
                        class="product-list__view-toggle-btn"
                        [class.active]="viewMode === 'table'"
                        (click)="toggleViewMode('table')"
                        title="List view"
                        aria-label="List view"
                    >
                        <div
                            class="product-list__view-toggle-btn-icon"
                            style="-webkit-mask-image: url('assets/icons/list-view.svg'); mask-image: url('assets/icons/list-view.svg');"
                        ></div>
                    </button>
                    <button
                        type="button"
                        class="product-list__view-toggle-btn"
                        [class.active]="viewMode === 'grid'"
                        (click)="toggleViewMode('grid')"
                        title="Grid view"
                        aria-label="Grid view"
                    >
                        <div
                            class="product-list__view-toggle-btn-icon"
                            style="-webkit-mask-image: url('assets/icons/grid-view.svg'); mask-image: url('assets/icons/grid-view.svg');"
                        ></div>
                    </button>
                </div>
            </div>

            <div class="product-list__bulk-buy" *ngIf="!isConsolidatedFeed && !isMobile && !supplierId">
                <button
                    type="button"
                    class="product-list__bulk-buy-head"
                    (click)="toggleBulkBuyPanel()"
                >
                    <div class="product-list__bulk-buy-title-row">
                        <span class="product-list__bulk-buy-icon-wrap" aria-hidden="true">
                            <img src="assets/icons/bulk-buy-list.svg" alt="" class="product-list__bulk-buy-icon" />
                        </span>
                        <span class="product-list__bulk-buy-title">Buying from a product list? Build your cart in minutes</span>
                    </div>
                    <span class="product-list__bulk-buy-toggle">
                        {{ bulkBuyOpen ? 'Hide' : 'Show' }}
                    </span>
                </button>
                <div class="product-list__bulk-buy-body" *ngIf="bulkBuyOpen">
                    <p class="product-list__bulk-buy-copy">
                        Paste your product codes below or upload a file. We'll ask for your preferences and build your cart automatically.
                    </p>
                    <div class="product-list__bulk-buy-actions">
                        <div class="product-list__bulk-buy-paste">
                            <textarea
                                class="product-list__bulk-buy-textarea"
                                rows="4"
                                placeholder="Paste GTINs here, one per line..."
                                [value]="bulkBuyPasteText"
                                (input)="onBulkBuyPasteInput($event)"
                                [disabled]="bulkBuyPasteSubmitting"
                            ></textarea>
                        </div>
                        <div class="product-list__bulk-buy-or">OR</div>
                        <div class="product-list__bulk-buy-drop">
                            <div class="product-list__bulk-buy-drop-copy">
                                <div class="product-list__bulk-buy-drop-title">Drop your file here</div>
                                <div class="product-list__bulk-buy-drop-hint">Supports files up to 10MB</div>
                            </div>
                            <vsf-upload-cart-csv
                                [consolidatedFeedImport]="isConsolidatedFeed"
                                buttonLabel="Choose file"
                                [customClass]="'product-list__bulk-buy-upload'"
                                [failedProductGtins]="failedProductGtins"
                                [moqViolations]="moqViolations"
                                (failedProductGtinsChange)="failedProductGtins = $event"
                                (moqViolationsChange)="moqViolations = $event"
                            ></vsf-upload-cart-csv>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="product-list__bulk-buy-build"
                        *ngIf="bulkBuyPasteText.trim()"
                        (click)="submitBulkBuyPaste()"
                        [disabled]="bulkBuyPasteSubmitting"
                    >
                        {{ bulkBuyPasteSubmitting ? 'Building…' : 'Build cart' }}
                    </button>
                    <div class="product-list__bulk-buy-email">
                        <img src="assets/icons/mail-icon.svg" alt="" />
                        <span
                            >Or email it to
                            <a href="mailto:price@venduro.io">price@venduro.io</a>
                            and we'll reply with your comparison.</span
                        >
                    </div>
                </div>
            </div>

            <div *ngIf="isConsolidatedFeed && !isMobile" class="cf-list-toolbar">
                <div class="cf-list-toolbar__left">
                    <form class="cf-list-toolbar__search" (submit)="$event.preventDefault(); submitConsolidatedFeedSearch()">
                        <img src="assets/icons/search-icon.svg" alt="" />
                        <input
                            type="search"
                            [(ngModel)]="consolidatedFeedSearchTerm"
                            name="consolidatedFeedSearch"
                            placeholder="Search this feed by product or EAN"
                            aria-label="Search this feed by product or EAN"
                            (input)="onConsolidatedFeedSearchInput()"
                            (search)="onConsolidatedFeedSearchInput()"
                        />
                    </form>
                    <div class="cf-list-toolbar__stats" *ngIf="unfilteredTotalItems > 0">
                        {{ unfilteredTotalItems | number }} SKUs
                        <ng-container *ngIf="getConsolidatedBrandCount() > 0">
                            · {{ getConsolidatedBrandCount() }} brands
                        </ng-container>
                    </div>
                </div>
                <vsf-upload-cart-csv
                                [consolidatedFeedImport]="isConsolidatedFeed"
                    [borderedToolbar]="true"
                    buttonLabel="Import cart"
                    [consolidatedFeedPricingIds]="consolidatedFeedPricingIds"
                    [failedProductGtins]="failedProductGtins"
                    [moqViolations]="moqViolations"
                    (failedProductGtinsChange)="failedProductGtins = $event"
                    (moqViolationsChange)="moqViolations = $event"
                ></vsf-upload-cart-csv>
            </div>

            <ng-container *ngIf="loading$ | async; else productsLoaded">
                <vsf-product-skeleton [count]="5"></vsf-product-skeleton>
            </ng-container>

            <ng-template #productsLoaded>
                <div *ngIf="viewMode === 'table' && !isConsolidatedFeed && !supplierId" class="animate-fade-in">
                    <ng-container *ngIf="products$ | async as products">
                        <div class="product-list__discovery" *ngIf="products.length > 0">
                            <div class="product-list__discovery-head">
                                <div>Product</div>
                                <div>Brand</div>
                                <div>GTIN</div>
                                <div>Best Price</div>
                                <div>vs Retail</div>
                                <div>Offers</div>
                            </div>
                            <a
                                *ngFor="let product of products; trackBy: trackByProductId"
                                class="product-list__discovery-row"
                                [routerLink]="['/product', product.slug, product.cheapestVariant?.supplierId]"
                            >
                                <div class="product-list__discovery-product">
                                    <div class="product-list__discovery-thumb">
                                        <img
                                            [src]="product.productAsset?.preview | productImageSrc : 'thumb' : product.productAsset?.id"
                                            vsfFallbackSrc
                                            [alt]="product.productName || 'Product'"
                                        />
                                        <span
                                            *ngIf="isHotOfferProduct(product)"
                                            class="product-list__discovery-hot"
                                            title="Hot offer"
                                        >
                                            <img src="assets/icons/hot-offer-flame.svg" alt="" />
                                        </span>
                                    </div>
                                    <div class="product-list__discovery-name">
                                        {{ product.productName | titlecase }}
                                    </div>
                                </div>
                                <div class="product-list__discovery-brand">
                                    {{ product.customProductMappings?.brand || '—' }}
                                </div>
                                <div
                                    class="product-list__discovery-gtin"
                                    (click)="copyToClipboard(product.customProductMappings?.gtin, $event); $event.preventDefault()"
                                >
                                    {{ product.customProductMappings?.gtin || '—' }}
                                    <img
                                        *ngIf="product.customProductMappings?.gtin"
                                        src="assets/icons/copy-icon.svg"
                                        alt=""
                                    />
                                </div>
                                <div class="product-list__discovery-price">
                                    <ng-container *ngIf="(isLoggedIn$ | async); else discoveryGuest">
                                        <span *ngIf="getCatalogOfferCount(product) > 1">from </span>{{ product.cheapestVariant?.priceWithTax | formatPrice }}
                                    </ng-container>
                                    <ng-template #discoveryGuest>
                                        <a [routerLink]="['/account/sign-in']" (click)="$event.stopPropagation()">Login</a>
                                    </ng-template>
                                </div>
                                <div class="product-list__discovery-retail">
                                    <span
                                        *ngIf="getCatalogMarginPercent(product) != null"
                                        class="product-list__discovery-margin"
                                    >
                                        −{{ getCatalogMarginPercent(product) }}%
                                        <vsf-retail-price-hint
                                            [productId]="product.productId"
                                        ></vsf-retail-price-hint>
                                    </span>
                                </div>
                                <div class="product-list__discovery-offers">
                                    {{ getCatalogOfferCount(product) }}
                                    {{ getCatalogOfferCount(product) === 1 ? 'offer' : 'offers' }}
                                </div>
                            </a>
                        </div>
                        <div *ngIf="products.length === 0 && (loading$ | async) === false">
                            <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                        </div>
                    </ng-container>
                    <vsf-product-list-pagination
                        [totalResults$]="totalResults$"
                        [currentPage$]="currentPage$"
                        [totalPages$]="totalPages$"
                        [perPage$]="perPage$"
                        [canGoPrevious$]="canGoPrevious$"
                        [canGoNext$]="canGoNext$"
                        [pageNumbers$]="getPageNumbers()"
                        (goToFirst)="goToFirstPage()"
                        (goToPrevious)="goToPreviousPage()"
                        (goToNext)="goToNextPage()"
                        (goToLast)="goToLastPage()"
                        (goToPage)="goToPage($event)"
                        (perPageChange)="changeItemsPerPage($event)"
                    ></vsf-product-list-pagination>
                </div>

                <div *ngIf="viewMode === 'table' && (isConsolidatedFeed || supplierId)" class="animate-fade-in">
                    <div class="product-list__table-container" [class.product-list__table-container--supplier]="!!supplierId">
                        <ng-container *ngIf="products$ | async as products">
                            <ng-container *ngIf="supplierId ? rememberSupplierPageProducts(products) : products"></ng-container>
                            <table class="product-list__table" [class.product-list__table--supplier]="!!supplierId" *ngIf="products.length > 0">
                                    <thead [class.product-list__table-head]="!isConsolidatedFeed">
                                        <tr>
                                            <th *ngIf="supplierId" class="product-list__table-check">
                                                <input
                                                    type="checkbox"
                                                    [checked]="allVisibleSupplierSelected"
                                                    (change)="toggleSelectAllVisibleSupplierProducts($event)"
                                                    aria-label="Select all products on this page"
                                                />
                                            </th>
                                            <th class="product-list__table-th-sort-name group" (click)="onSort('name')">
                                                <div class="flex items-center gap-2">
                                                    <span class="group-hover:text-primary-600 transition-colors">Product</span>
                                                    <div class="product-list__sort-arrows" [class.opacity-100]="sortField === 'name'">
                                                        <img src="assets/icons/triangle-up.svg" alt="" class="w-2.5 h-2.5" [class.text-primary-600]="sortField === 'name' && sortOrder === 'ASC'" />
                                                        <img src="assets/icons/triangle-up.svg" alt="" class="w-2.5 h-2.5 rotate-180" [class.text-primary-600]="sortField === 'name' && sortOrder === 'DESC'" />
                                                    </div>
                                                </div>
                                            </th>
                                            <th *ngIf="isConsolidatedFeed">EAN</th>
                                            <th *ngIf="isConsolidatedFeed">Brand</th>
                                            <th *ngIf="!isConsolidatedFeed" class="res-hide-1000">EAN</th>
                                            <th *ngIf="!isConsolidatedFeed && !supplierId">Supplier</th>
                                            <th class="product-list__table-th-sort-price group" (click)="onSort('price')">
                                                <div class="flex items-center gap-2">
                                                    <span class="group-hover:text-primary-600 transition-colors">Price</span>
                                                    <div class="product-list__sort-arrows" [class.opacity-100]="sortField === 'price'">
                                                        <img src="assets/icons/triangle-up.svg" alt="" class="w-2.5 h-2.5" [class.text-primary-600]="sortField === 'price' && sortOrder === 'ASC'" />
                                                        <img src="assets/icons/triangle-up.svg" alt="" class="w-2.5 h-2.5 rotate-180" [class.text-primary-600]="sortField === 'price' && sortOrder === 'DESC'" />
                                                    </div>
                                                </div>
                                            </th>
                                            <th class="whitespace-nowrap" *ngIf="supplierId">vs Retail</th>
                                            <th class="res-hide-1000 whitespace-nowrap" *ngIf="!isConsolidatedFeed && !supplierId">Retail Price</th>
                                            <th *ngIf="isConsolidatedFeed" class="whitespace-nowrap">vs. retail</th>
                                            <th *ngIf="!supplierId && !isConsolidatedFeed"></th>
                                            <th *ngIf="!supplierId">{{ isConsolidatedFeed ? 'Available' : 'Availablity' }}</th>
                                            <th *ngIf="!isConsolidatedFeed && !supplierId" class="res-hide-1200">Shipping Date</th>
                                            <th class="pr-10" [class.text-right]="isConsolidatedFeed || !!supplierId">
                                                {{ supplierId ? 'Quantity' : (isConsolidatedFeed ? 'Quick add' : 'Action') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let product of products; trackBy: trackByProductId">
                                            <tr>
                                                <td *ngIf="supplierId" class="product-list__table-check">
                                                    <input
                                                        type="checkbox"
                                                        [checked]="isSupplierProductSelected(product.productId)"
                                                        (change)="toggleSupplierProductSelected(product.productId, $event)"
                                                        [attr.aria-label]="'Select ' + (product.productName || 'product')"
                                                    />
                                                </td>
                                                <td class="pl-2 min-w-[320px]">
                                                    <div class="flex items-center gap-2">
                                                        <a [routerLink]="['/product', product.slug, product.cheapestVariant?.supplierId]" class="product-list__product-thumb group">
                                                            <img
                                                                [src]="product.productAsset?.preview | productImageSrc : 'thumb' : product.productAsset?.id"
                                                                class="w-full h-full object-contain"
                                                                vsfFallbackSrc
                                                                [attr.alt]="product.productName || 'Product'"
                                                            />
                                                            <span
                                                                role="button"
                                                                tabindex="0"
                                                                class="product-list__zoom-trigger product-list__zoom-trigger--table"
                                                                *ngIf="hasRealProductImage(product)"
                                                                [attr.aria-label]="'Enlarge image: ' + (product.productName || 'Product')"
                                                                (click)="openImageModal(product.productAsset?.preview); $event.stopPropagation(); $event.preventDefault()"
                                                                (keydown.enter)="openImageModal(product.productAsset?.preview); $event.stopPropagation(); $event.preventDefault()"
                                                                (keydown.space)="$event.preventDefault(); openImageModal(product.productAsset?.preview); $event.stopPropagation()"
                                                            >
                                                                <img src="assets/icons/zoom-in.svg" alt="" class="product-list__zoom-trigger-icon" />
                                                            </span>
                                                        </a>
                                                        <div class="product-list__product-meta">
                                                            <a [routerLink]="['/product', product.slug, product.cheapestVariant?.supplierId]" class="product-list__product-name text-[14px]">{{ product.productName | titlecase }}</a>
                                                            <span *ngIf="!isConsolidatedFeed" class="text-[11px] text-gray-400 uppercase tracking-wider">{{ product.customProductMappings?.brand }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                           
                                                <td *ngIf="isConsolidatedFeed" class="product-list__table-cell-ean font-inter text-[13px] text-gray-700 whitespace-nowrap">
                                                    <div class="flex items-center gap-1.5 group/ean">
                                                        {{ product.customProductMappings?.gtin || '—' }}
                                                        <button
                                                            *ngIf="product.customProductMappings?.gtin"
                                                            (click)="copyToClipboard(product.customProductMappings?.gtin, $event)"
                                                            class="product-list__ean-copy-btn"
                                                            title="Copy EAN"
                                                            aria-label="Copy EAN"
                                                        >
                                                            <img src="assets/icons/copy-icon.svg" alt="" class="w-3.5 h-3.5" />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td *ngIf="isConsolidatedFeed" class="text-[13px] text-[#1f2a44] whitespace-nowrap">
                                                    {{ product.customProductMappings?.brand || '—' }}
                                                </td>
                                                <td *ngIf="!isConsolidatedFeed" class="product-list__table-cell-ean font-inter res-hide-1000">
                                                    <div class="flex items-center gap-1.5 group/ean">
                                                        {{ product.customProductMappings?.gtin }}
                                                        <button (click)="copyToClipboard(product.customProductMappings?.gtin, $event)" class="product-list__ean-copy-btn" title="Copy EAN" aria-label="Copy EAN">
                                                            <img src="assets/icons/copy-icon.svg" alt="" class="w-3.5 h-3.5" />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td *ngIf="!isConsolidatedFeed && !supplierId" class="product-list__blur-container" [class.product-list__blurred]="(isLoggedIn$ | async) === false">
                                                    <a *ngIf="isValidSupplierId(product.cheapestVariant?.supplierId)" [routerLink]="['/category/products', product.cheapestVariant?.supplierId]" class="product-list__supplier-link group/supplier">
                                                        #{{ product.cheapestVariant?.supplierId }}
                                                        <img src="assets/icons/external-link.svg" alt="" class="product-list__supplier-link-icon" />
                                                    </a>
                                                     <div class="product-list__blur-overlay" *ngIf="(isLoggedIn$ | async) === false"></div>
                                                </td>

                                                <ng-container *ngIf="(isLoggedIn$ | async) === false; else authenticatedTable">
                                                    <td [attr.colspan]="supplierId ? 5 : 7" class="p-0 border-b border-gray-100">
                                                        <div class="product-list__blur-container">
                                                            <div class="product-list__blur-skeleton-row product-list__blurred">
                                                                <div class="w-[80px] h-4 bg-gray-200 rounded"></div>
                                                                <div class="w-[60px] h-4 bg-gray-200 rounded"></div>
                                                                <div class="w-[60px] h-4 bg-gray-200 rounded"></div>
                                                                <div class="w-[60px] h-4 bg-gray-200 rounded"></div>
                                                                <div class="w-[80px] h-4 bg-gray-200 rounded"></div>
                                                                <div class="w-[100px] h-8 bg-gray-200 rounded"></div>
                                                            </div>
                                                            <div class="product-list__blur-overlay">
                                                                <a [routerLink]="['/account/sign-in']" class="product-list__blur-message">Login to see wholesale prices</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </ng-container>

                                                <ng-template #authenticatedTable>
                                                    <td class="font-semibold text-gray-900 text-[13px] font-inter tabular-nums">{{ product.cheapestVariant?.priceWithTax | formatPrice }}</td>
                                                    <td *ngIf="supplierId" class="whitespace-nowrap">
                                                        <span
                                                            *ngIf="getCatalogMarginPercent(product) != null"
                                                            class="product-list__vs-retail"
                                                        >
                                                            −{{ getCatalogMarginPercent(product) }}%
                                                            <vsf-retail-price-hint
                                                                [productId]="product.productId"
                                                            ></vsf-retail-price-hint>
                                                        </span>
                                                        <span *ngIf="getCatalogMarginPercent(product) == null">—</span>
                                                    </td>
                                                    <td class="text-[13px] font-normal text-gray-700 font-inter res-hide-1000 whitespace-nowrap" *ngIf="!isConsolidatedFeed && !supplierId">
                                                        <span *ngIf="formatRetailPriceRange(product.productId)" class="mr-1.5 font-medium text-[#101828] tabular-nums">
                                                            {{ formatRetailPriceRange(product.productId) }}
                                                        </span>
                                                        <vsf-retail-price-hint
                                                            [productId]="product.productId"
                                                        ></vsf-retail-price-hint>
                                                    </td>
                                                    <td *ngIf="isConsolidatedFeed" class="text-[13px] font-medium tabular-nums">
                                                        <vsf-retail-price-hint
                                                            *ngIf="hasRetailPriceRange(product.productId)"
                                                            [productId]="product.productId"
                                                        ></vsf-retail-price-hint>
                                                    </td>
                                                    <td class="text-[13px] font-normal text-primary-500" *ngIf="!supplierId && !isConsolidatedFeed">
                                                        <button (click)="toggleOffers(product.productId)" class="product-list__offers-toggle" aria-label="Toggle offers">
                                                            {{ product.variants.length }} {{ product.variants.length === 1 ? 'offer' : 'offers' }}
                                                            <img *ngIf="product.variants.length > 1" src="assets/icons/chevron-down-outline.svg" alt="" class="product-list__offers-toggle-icon" [class.rotate-180]="expandedProductIds.has(product.productId)" />
                                                        </button>
                                                    </td>
                                                    <td class="text-[13px] font-semibold text-gray-900 font-inter" *ngIf="!supplierId">
                                                        <ng-container *ngIf="isConsolidatedFeed; else defaultAvailability">
                                                            {{ formatConsolidatedAvailability(product.cheapestVariant) }}
                                                        </ng-container>
                                                        <ng-template #defaultAvailability>
                                                        <ng-container *ngIf="product.cheapestVariant?.supplyType === 'pre-order'; else normalStock">
                                                            <span class=" font-normal">Pre-Order</span>
                                                        </ng-container>
                                                        <ng-template #normalStock>
                                                            <span *ngIf="(product.cheapestVariant?.qty || 0) > 0; else outOfStock">
                                                                {{ product.cheapestVariant?.qty }}
                                                                <span *ngIf="product.variants.length > 1" class="text-[13px] text-gray-600 font-normal">({{ getTotalQty(product) }} total)</span>
                                                            </span>
                                                            <ng-template #outOfStock>
                                                                <span class="text-red-600 font-normal">Out of Stock</span>
                                                            </ng-template>
                                                        </ng-template>
                                                        </ng-template>
                                                    </td>
                                                    <td *ngIf="!isConsolidatedFeed && !supplierId" class="product-list__table-cell-shipping font-inter res-hide-1200">{{ getShippingDateDisplay(product.cheapestVariant) }}</td>

                                                    <td class="pr-10 text-right"><div class="inline-flex flex-col items-end ">
                                                        <div class="product-list__table-actions">
                                                            <div class="product-list__qty-stepper">
                                                                <button class="product-list__qty-stepper-btn" (click)="decreaseQuantity(product.productId, product.cheapestVariant, product)" aria-label="Decrease quantity">-</button>
                                                                <input type="text" aria-label="Quantity" [value]="getQuantity(product.productId, product.cheapestVariant, product)" (change)="onQuantityChange(product.productId, product.cheapestVariant, $event, product)" class="product-list__qty-input font-inter" />
                                                                <button class="product-list__qty-stepper-btn" (click)="increaseQuantity(product.productId, product.cheapestVariant, product)" aria-label="Increase quantity">+</button>
                                                            </div>
                                                            <button (click)="addToCart({productId: product.productId, variantId: product.cheapestVariant?.id, quantity: getQuantity(product.productId, product.cheapestVariant, product)})" class="product-list__add-to-cart-btn" aria-label="Add to cart">
                                                                <img src="assets/icons/cart-icon-white.svg" class="w-4 h-4" alt="" />
                                                            </button>
                                                        </div>
                                                    
                                                        <span class="product-list__qty-info" *ngIf="product.cheapestVariant && !hasMinQ(product.cheapestVariant) && getMoq(product.cheapestVariant) > 1">
                                                            {{ TEXT.MOQ_PREFIX }} {{ getMoq(product.cheapestVariant) }} {{ TEXT.MOQ_SUFFIX }}
                                                        </span>
                                                        <span class="product-list__qty-info" *ngIf="product.cheapestVariant && hasMinQ(product.cheapestVariant)">
                                                            {{ getQuantityInfoText(product.cheapestVariant) }}
                                                        </span>
                                                        <span class="product-list__qty-info" *ngIf="getBundleLabel(product.cheapestVariant, product, getSupplierFullPackageOnly()) as bundleLabel">
                                                            {{ bundleLabel }}
                                                        </span>
                                                    </div>
                                                    </td>
                                                </ng-template>
                                            </tr>

                                            <ng-container *ngIf="(isLoggedIn$ | async) === true && expandedProductIds.has(product.productId)">
                                                <tr *ngFor="let variant of getOtherOffers(product)" class="product-list__offer-subrow">
                                                    <td class="pl-6 py-3"></td>
                                                    <td class="res-hide-1000"></td>
                                                    <td class="product-list__blur-container">
                                                        <a *ngIf="isValidSupplierId(variant.supplierId)" [routerLink]="['/product', product.slug, variant.supplierId]" class="product-list__sub-supplier-link group/sub-supplier">
                                                            #{{ variant.supplierId }}
                                                            <svg class="product-list__sub-supplier-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                        </a>
                                                    </td>

                                                        <td class="font-semibold text-gray-900 text-[13px] font-inter">{{ variant.priceWithTax | formatPrice }}</td>
                                                        <td class="res-hide-1000"></td>
                                                        <td></td> 
                                                        <td class="text-[13px] font-semibold text-gray-900 font-inter">
                                                            <ng-container *ngIf="variant.supplyType === 'pre-order'; else subNormalStock">
                                                                <span class="text-gray-900">Pre-Order</span>
                                                            </ng-container>
                                                            <ng-template #subNormalStock>
                                                                <span *ngIf="(variant.qty || 0) > 0; else subOutOfStock">
                                                                    {{ variant.qty }}
                                                                </span>
                                                                <ng-template #subOutOfStock>
                                                                    <span class="text-red-600 font-normal">Out of Stock</span>
                                                                </ng-template>
                                                            </ng-template>
                                                        </td>
                                                        <td class="product-list__table-cell-shipping product-list__table-cell-shipping--nowrap font-inter res-hide-1200">{{ getShippingDateDisplay(variant) }}</td>

                                                        <td class="text-center"><div class="inline-flex flex-col items-center align-middle">
                                                            <div class="product-list__table-actions product-list__table-actions--variant">
                                                                <div class="product-list__qty-stepper">
                                                                    <button class="product-list__qty-stepper-btn" (click)="decreaseQuantity(product.productId, variant, product)" aria-label="Decrease quantity">-</button>
                                                                    <input type="text" aria-label="Quantity" [value]="getQuantity(product.productId, variant, product)" (change)="onQuantityChange(product.productId, variant, $event, product)" class="product-list__qty-input font-inter" />
                                                                    <button class="product-list__qty-stepper-btn" (click)="increaseQuantity(product.productId, variant, product)" aria-label="Increase quantity">+</button>
                                                                </div>
                                                                <button (click)="addToCart({productId: product.productId, variantId: variant.id, quantity: getQuantity(product.productId, variant, product)})" class="product-list__add-to-cart-btn" aria-label="Add to cart">
                                                                    <img src="assets/icons/cart-icon-white.svg" class="w-4 h-4" alt="" />
                                                                </button>
                                                            </div>
                                                        
                                                                <span class="product-list__qty-info text-center" *ngIf="variant && !hasMinQ(variant) && getMoq(variant) > 1">
                                                                    {{ TEXT.MOQ_PREFIX }} {{ getMoq(variant) }} {{ TEXT.MOQ_SUFFIX }}
                                                                </span>
                                                                <span class="product-list__qty-info text-center" *ngIf="variant && hasMinQ(variant)">
                                                                    {{ getQuantityInfoText(variant) }}
                                                                </span>
                                                                <span class="product-list__qty-info text-center" *ngIf="getBundleLabel(variant, product, getSupplierFullPackageOnly()) as bundleLabel">
                                                                    {{ bundleLabel }}
                                                                </span>
                                                            </div>
                                                        </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                            </table>

                            <div *ngIf="products.length === 0 && (loading$ | async) === false">
                                <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <vsf-product-list-pagination
                        [totalResults$]="totalResults$"
                        [currentPage$]="currentPage$"
                        [totalPages$]="totalPages$"
                        [perPage$]="perPage$"
                        [canGoPrevious$]="canGoPrevious$"
                        [canGoNext$]="canGoNext$"
                        [pageNumbers$]="getPageNumbers()"
                        (goToFirst)="goToFirstPage()"
                        (goToPrevious)="goToPreviousPage()"
                        (goToNext)="goToNextPage()"
                        (goToLast)="goToLastPage()"
                        (goToPage)="goToPage($event)"
                        (perPageChange)="changeItemsPerPage($event)"
                    ></vsf-product-list-pagination>
                </div>

                <div *ngIf="viewMode === 'grid' && !supplierId" class="animate-fade-in">
                    <ng-container *ngIf="products$ | async as products">
                        <div class="product-list__grid-shell" *ngIf="products.length > 0">
                            <div class="product-list__grid">
                                <vsf-product-list-grid-item
                                    *ngFor="let product of products; trackBy: trackByProductId"
                                    [product]="product"
                                    [isLoggedIn]="isLoggedIn$ | async"
                                    [supplyTypes]="activeSupplyTypes"
                                    [retailPriceRange]="retailPriceRanges[product.productId]"
                                ></vsf-product-list-grid-item>
                            </div>
                        </div>

                        <vsf-product-list-pagination
                            [totalResults$]="totalResults$"
                            [currentPage$]="currentPage$"
                            [totalPages$]="totalPages$"
                            [perPage$]="perPage$"
                            [canGoPrevious$]="canGoPrevious$"
                            [canGoNext$]="canGoNext$"
                            [pageNumbers$]="getPageNumbers()"
                            (goToFirst)="goToFirstPage()"
                            (goToPrevious)="goToPreviousPage()"
                            (goToNext)="goToNextPage()"
                            (goToLast)="goToLastPage()"
                            (goToPage)="goToPage($event)"
                            (perPageChange)="changeItemsPerPage($event)"
                        ></vsf-product-list-pagination>

                        <div *ngIf="products.length === 0 && (loading$ | async) === false">
                            <ng-container [ngTemplateOutlet]="noResults"></ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-template>
        <vsf-product-list-zoom-modal
            [zoomedImage]="zoomedImage"
            (close)="closeImageModal()"
        ></vsf-product-list-zoom-modal>

        <ng-template #noResults>
            <div class="product-list__no-results">
                <p class="product-list__no-results-text">No products found</p>
                <img src="assets/icons/sad-face.svg" alt="" class="w-16 h-16" />
            </div>
        </ng-template>
    </div>
    </div>

    <div class="supplier-sticky" *ngIf="supplierId && supplierInfo">
        <div class="supplier-sticky__inner">
            <div class="supplier-sticky__left">
                <span *ngIf="getSupplierCartUnitCount() === 0">No items yet</span>
                <span *ngIf="getSupplierCartUnitCount() > 0">
                    {{ getSupplierCartUnitCount() }}
                    {{ getSupplierCartUnitCount() === 1 ? 'item' : 'items' }}
                </span>
                <span class="supplier-sticky__total">{{ supplierSpecificTotal | formatPrice }}</span>
            </div>
            <div class="supplier-sticky__center">{{ getSupplierStickyMessage() }}</div>
            <a routerLink="/cart" class="supplier-sticky__cta">Go to cart</a>
        </div>
    </div>
</div>